import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import DocSummary from './DocSummary';
import NewDocsModal from './NewDocsModal';

import docsAssocGroupStyles from '../assets/jss/crm/components/docsAssocGroupStyles';

class DocsAssocGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldShowDocuments: true,
      shouldShowNewDocModal: false,
    };
  }

  toggleDocumentsVisibility() {
    this.setState({ shouldShowDocuments: !this.state.shouldShowDocuments });
  }

  showAllDocuments() {
    this.setState({ shouldShowDocuments: true });
  }

  showUIToAddNewDocument(event) {
    event.stopPropagation();
    this.setState({ shouldShowNewDocModal: true });
  }

  createDocumentsSummaries(allRelatedDocs, parent) {
    return (
      <div>
        {allRelatedDocs.map((doc) => (
          <DocSummary key={doc.storedDocumentId} document={doc} parent={parent} />
        ))}
      </div>
    );
  }

  render() {
    const { classes, allRelevantDocs, visibleFirmId, clientId, inquiryId, parent } = this.props;
    return (
      <div>
        <NewDocsModal
          show={this.state.shouldShowNewDocModal}
          visibleFirmId={visibleFirmId}
          clientId={clientId}
          inquiryId={inquiryId}
          parent={parent}
          closeModalFunc={() => this.setState({ shouldShowNewDocModal: false })}
        />
        <div className={classes.entityAssocGroup}>
          <div className={classes.entityAssocGroup_header} onClick={() => this.toggleDocumentsVisibility()}>
            <div className={classes.quickAddToggle} onClick={(event) => this.showUIToAddNewDocument(event)}>
              <div className={classes.addOneButton + ' ' + classes.button_icon}>
                <i className="zmdi zmdi-plus" />
              </div>
            </div>
            <div className={classes.entityAssocGroup_title + ' ' + classes.ac_h4}>
              Documents ({allRelevantDocs.length})&nbsp;
              {allRelevantDocs.length ? (
                <i
                  className={cx(
                    classes.entityAssocGroup_expand,
                    'zmdi',
                    { 'zmdi-chevron-up': this.state.shouldShowDocuments },
                    { 'zmdi-chevron-down': !this.state.shouldShowDocuments }
                  )}
                />
              ) : null}
            </div>
          </div>
          {this.state.shouldShowDocuments && this.createDocumentsSummaries(allRelevantDocs, parent)}
        </div>
      </div>
    );
  }
}

export default withStyles(docsAssocGroupStyles)(DocsAssocGroup);
